import { Chip, Tooltip } from "@mui/material";

type StatusChipProps = {
  color: string;
  label: string;
  info: string;
};

export default function StatusChip({ color, label, info }: StatusChipProps) {
  const textColor = color === "white" ? "black" : "white";
  return (
    <Tooltip
      title={info}
      sx={{
        backgroundColor: color,
        color: color,
      }}
      placement="left"
      arrow={true}
    >
      <Chip
        size="small"
        label={label}
        sx={{
          backgroundColor: color,
          color: textColor,
        }}
      />
    </Tooltip>
  );
}
